import { getSettlementById } from "@/services/settlements.service";
import { useQuery } from "@tanstack/react-query";

export const useSettlement = (id, options = {}) => {
  return useQuery({
    queryKey: ["settlement", id],
    queryFn: () => getSettlementById(id),
    enabled: Boolean(id),
    select: (res) => res?.data,
    ...options,
  });
};
